import { mailApiGet, mailApiPost } from "./client";

export type PeriodWarmFolderScan = {
  name: string;
  label: string;
  depth: number;
  count: number;
};

export type PeriodWarmScan = {
  periodDays: number;
  sinceDate: string;
  total: number;
  folders: PeriodWarmFolderScan[];
};

export type PeriodWarmJob = {
  id: string;
  status: "running" | "paused" | "completed" | "cancelled" | "idle";
  periodDays: number;
  sinceDate: string;
  phase: "bodies";
  currentFolder: string | null;
  folders: string[];
  totalMessages: number;
  headersDone: number;
  bodiesDone: number;
  progress: number;
  updatedAt: number;
};

export function fetchPeriodScan(accountId: number, days: 7 | 14 | 30) {
  const qs = new URLSearchParams();
  qs.set("accountId", String(accountId));
  qs.set("days", String(days));
  return mailApiGet<{ success: boolean; scan: PeriodWarmScan }>(
    `imap/period-scan.php?${qs.toString()}`
  );
}

export function fetchPeriodWarmStatus(accountId: number) {
  const qs = new URLSearchParams();
  qs.set("accountId", String(accountId));
  return mailApiGet<{ success: boolean; job: PeriodWarmJob | null }>(
    `imap/period-warm.php?${qs.toString()}`
  );
}

export function startPeriodWarm(
  accountId: number,
  days: 7 | 14 | 30,
  folders: string[],
  totalMessages?: number
) {
  return mailApiPost<{ success: boolean; job: PeriodWarmJob }>("imap/period-warm.php", {
    action: "start",
    accountId,
    days,
    folders,
    totalMessages: totalMessages ?? 0,
  });
}

export function pausePeriodWarm(accountId: number) {
  return mailApiPost<{ success: boolean; job: PeriodWarmJob | null }>("imap/period-warm.php", {
    action: "pause",
    accountId,
  });
}

export function resumePeriodWarm(accountId: number) {
  return mailApiPost<{ success: boolean; job: PeriodWarmJob | null }>("imap/period-warm.php", {
    action: "resume",
    accountId,
  });
}

export function cancelPeriodWarm(accountId: number) {
  return mailApiPost<{ success: boolean; job: null }>("imap/period-warm.php", {
    action: "cancel",
    accountId,
  });
}
